// LICENSE_CODE ZON
'use strict'; /*jslint react:true*/
import React, {useState, useEffect, useCallback} from 'react';
import {useStore} from '@nanostores/react';
import etask from '/util/etask.js';
import {$user} from '../../store/user.js';
import store from '../../store.js';
import * as api from '../../api.js';
import {APP_TITLE} from '../../utils/constants.js';
import {Popup} from '../../comp/popup';
import {Checkbox} from '../../comp/checkbox';
import {Downloads} from '../../comp/downloads';
import {alert} from '../../comp/alert';
import * as cns from './onboarding.module.less';

export function Onboarding(){
    const [{list}] = store.use_devices();
    const user = useStore($user);
    const [show_popup, set_show_popup] = useState(false);
    const [dont_show_again, set_dont_show_again] = useState(false);
    useEffect(()=>{
        if (user.onboarding || list.length)
            return;
        set_show_popup(true);
    }, [user]);
    const on_close = useCallback(()=>etask(function*(){
        this.on('uncaught', console.error);
        if (dont_show_again)
        {
            let res;
            try {
                res = yield api.mark_onboarding();
            } catch(e){
                res = {error: e.message};
            }
            if (res.error)
            {
                alert({
                    title: 'Error while saving onboarding data',
                    text: res.error,
                    negative: true,
                });
            }
        }
        set_show_popup(false);
    }), [dont_show_again]);
    const handle_dont_show_click = useCallback(set_dont_show_again, []);
    return <Popup title={`Welcome to ${APP_TITLE}`} show={show_popup}
      hide_actions on_close={on_close}>
      <div className={cns.inner}>
        <Downloads/>
        <Checkbox checked={dont_show_again} on_change={handle_dont_show_click}
          label="Don't show this message again"/>
      </div>
    </Popup>;
}
